// ПАСПОРТ ДОКУМЕНТА ИЗ КОНВЕРТА — один на шаги 5–7, окно Open, слепок и PDF. Тикет кнопок шага 3
// `3f819875cbb881caaf4aca9568ca5616` (s987), решение `s987.d4`.
//
// ⭐ ВВОД ДОКУМЕНТА = ЭТАПЫ + ПОЛЗУНКИ + КНОПКИ (BG1–BG4, свой ответ BG3 уже разрешён в строку). §II печатает
// выборы напрямую (`s331`/`s369.d2`), §IV — пилюли `bg1/bg2`. До этого шаги 5–7 строили паспорт из
// `{ vals }` без `grp`/`cust`, и на §II стояли пустые pulled in / top fuel / living for / what's left.
//
// ⛔ T1–T3 (свободные ответы панели C) В ДОКУМЕНТ НЕ ИДУТ: это сырьё (`s490.d1`), их читает только судья
// цитат. Свой ответ кнопки (`cust`) — идёт: он напечатан в §II и потому часть документа (`s987.d4`), в
// той форме, в какой печатается (кап 64 стоит на вводе, `deckField.js`, B5-4).
//
// System 1 кнопки не читает (`detect()` — только ползунки), поэтому выход движка от кнопок не меняется.
//
// ⭐ `system2` — ИЗ КОНВЕРТА (строка 73, `s987.d3`, `quotes.js`): вырезки судьи, посчитанные под текущие тексты и
// несущие этапы. Не посчитан или вход сменился — `null`, и рендер ведёт себя как без судьи (§VI снят,
// цитаты §IV/§VII молчат). Сами T1–T3 сюда по-прежнему не едут.

import { useMemo } from 'react';

import { toWizardInput } from './toWizardInput.js';
import { custAt, groupsAt } from './submitChain.js';
import { quotesOf } from './quotes.js';
import { buildPassport } from '../render/passportData.js';

/** `WizardInput` документа: без `text`. Бросает то же, что `toWizardInput`. */
export function documentInputOfSession(session) {
  const { stages, sliders, buttons, cust } = session.input;
  const n = Array.isArray(sliders) ? sliders.length : 0;
  const at = (fn, rows) => Array.from({ length: n }, (_, k) => fn(rows, k));
  return toWizardInput(
    { rows: stages },
    { vals: sliders, grp: at(groupsAt, buttons), cust: at(custAt, cust) },
    { nowY: session.nowY },
  );
}

/** Несущие этапы паспорта документа — второй половиной ключа судьи (`quotes.js`). Бросает, как `toWizardInput`. */
export function documentCarrierOf(session) {
  return buildPassport(documentInputOfSession(session)).carrierStages.indices;
}

export function passportOfSession(session) {
  return withQuotes(buildPassport(documentInputOfSession(session)), session);
}

/** Паспорт + `system2` конверта, если тот посчитан под текущий вход. Без цитат — тот же объект. */
function withQuotes(p, session) {
  const system2 = quotesOf(session, p.carrierStages.indices);
  return system2 ? { ...p, system2 } : p;
}

/**
 * Паспорт шага своей серией на маунте (`s472.d2`) — пересчёт только при смене ввода документа или ВЫРЕЗОК.
 * Две ступени намеренно: запись `quotes` без цитат (судья ничего не нашёл, текста нет) не меняет паспорт по
 * ссылке, а по ссылке шаг 7 узнаёт «тот же документ» (токен слепка, пре-генерация PDF).
 */
export function useDocumentPassport(session) {
  const { stages, sliders, buttons, cust, text } = session.input;
  const { nowY, quotes } = session;
  const base = useMemo(
    () => buildPassport(documentInputOfSession({ nowY, input: { stages, sliders, buttons, cust } })),
    [stages, sliders, buttons, cust, nowY],
  );
  const system2 = useMemo(
    () => quotesOf({ quotes, input: { sliders, text } }, base.carrierStages.indices),
    [quotes, sliders, text, base],
  );
  return useMemo(() => (system2 ? { ...base, system2 } : base), [base, system2]);
}
